import { Menu } from "lucide-react";
import LogoutButton from "./LogoutButton";
import NotificationsDropdown from "./NotificationsDropdown";

/* TopBar — sits above the main content. Houses:
   - hamburger (mobile only, opens the sidebar)
   - NotificationsDropdown (bell + panel with today's activity feed)
   - LogoutButton (avatar + name + role + sign-out dropdown) */

export function TopBar({ onOpenSidebar }) {
  return (
    <header className="h-14 bg-white border-b border-slate-200 flex items-center gap-2 sm:gap-3 px-3 sm:px-4 shrink-0">
      <button
        onClick={onOpenSidebar}
        className="lg:hidden text-slate-500 shrink-0"
        aria-label="Open sidebar"
      >
        <Menu className="w-5 h-5" />
      </button>
      <div className="ml-auto flex items-center gap-2 sm:gap-3 shrink-0">
        <NotificationsDropdown />
        <div className="pl-2 sm:pl-3 border-l border-slate-200">
          <LogoutButton />
        </div>
      </div>
    </header>
  );
}
